import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sign-in"
}
const _hoisted_2 = {
  class: "sign-in__button",
  href: "/booking/login"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = { class: "quantity-container" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "quantity" }
const _hoisted_7 = {
  key: 0,
  class: "quantity-container"
}
const _hoisted_8 = { class: "quantity" }
const _hoisted_9 = { class: "footer" }
const _hoisted_10 = { class: "checkboxes" }
const _hoisted_11 = { class: "button" }

import { Direction } from "@/models/Enums";
import { passengerOptions } from "@/modules/Quickform/config/passengerOptions";
import { usePassengerStore } from "@/store/passengerStore";
import { Ref, computed, ref } from "vue";
import PassengerSelectRow from "./PassengerSelectRow.vue";
import { VBtn, VCheckbox } from "v-ferry-components";
import SvgIcon from "@/components/base/SvgIcon.vue";
import { onClickOutside } from "@vueuse/core";
import { sessionKeys } from "@/config/sessionKeys";

interface Props {
    errorMessage?: string;
    next?: Ref<any>;
    hasReturn?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PassengersForm',
  props: {
    errorMessage: {},
    next: {},
    hasReturn: { type: Boolean }
  },
  emits: ["onPassengerSelect"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const showDropdown = ref(false);

const dropdownTarget = ref();

onClickOutside(dropdownTarget, () => (showDropdown.value = false));

const passengerStore = usePassengerStore();

const concession = ref(false);

const differentDetails = computed({
    get(): boolean {
        return passengerStore.getDifferentDetails;
    },
    set(isDifferentDetails: boolean) {
        passengerStore.setDifferentDetails(isDifferentDetails);
    },
});

const options = computed(() => (concession.value ? passengerOptions : passengerOptions.filter((p) => p.displayDefault === true)));

const isLoggedIn = computed(() => {
    var sessionUser = sessionStorage.getItem(sessionKeys.user);
    if (!sessionUser) return;
    const user = JSON.parse(sessionUser);
    return user != null ? !!user.loggedIn : false;
});

const closeSelect = () => {
    emit("onPassengerSelect");
    showDropdown.value = false;
};

const toggleDropdown = () => {
    if (showDropdown.value) {
        closeSelect();
    } else {
        showDropdown.value = true;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(VBtn), {
      class: _normalizeClass(["dropdown-btn inputs__dropdown", { hasError: _ctx.errorMessage }]),
      color: "ghost",
      onClick: toggleDropdown,
      type: "button"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_unref(passengerStore).getPassengersPlaceholder(_ctx.hasReturn)), 1),
        _createVNode(SvgIcon, {
          class: _normalizeClass(["icon", { open: showDropdown.value }]),
          icon: "carbon/chevron-down"
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 8, ["class"]),
    (showDropdown.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "dropdownTarget",
          ref: dropdownTarget,
          class: _normalizeClass(["dropdown", { double: differentDetails.value && _ctx.hasReturn }])
        }, [
          (!isLoggedIn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("h5", null, "Are you an Islander?", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("h5", null, "Do you have a NorthLink ID?", -1)),
                _createElementVNode("a", _hoisted_2, [
                  _createVNode(_unref(VBtn), {
                    type: "button",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Sign In")
                    ])),
                    _: 1,
                    __: [2]
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["passenger-select", { return: differentDetails.value && _ctx.hasReturn }])
          }, [
            _createElementVNode("div", _hoisted_4, [
              (differentDetails.value && _ctx.hasReturn)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_5, "Outward"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
                  return (_openBlock(), _createBlock(PassengerSelectRow, {
                    key: index,
                    option: option,
                    direction: _unref(Direction).Outward
                  }, null, 8, ["option", "direction"]))
                }), 128))
              ])
            ]),
            (differentDetails.value && _ctx.hasReturn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createElementVNode("h5", null, "Return", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
                      return (_openBlock(), _createBlock(PassengerSelectRow, {
                        class: "return-passenger",
                        key: option.passengerType,
                        option: option,
                        direction: _unref(Direction).Return
                      }, null, 8, ["option", "direction"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(VCheckbox), {
                modelValue: concession.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((concession).value = $event)),
                id: "concessions",
                label: "Access other concessions"
              }, null, 8, ["modelValue"]),
              (_ctx.hasReturn)
                ? (_openBlock(), _createBlock(_unref(VCheckbox), {
                    key: 0,
                    modelValue: differentDetails.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((differentDetails).value = $event)),
                    id: "differentDetails",
                    label: "Different details for return"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(VBtn), {
                onClick: closeSelect,
                type: "button"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Done")
                ])),
                _: 1,
                __: [6]
              })
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})